import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@/components/page'
import { Button } from '@/components/ui/button'
import type { RouterContext } from '@/router'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: NotFound,
})

function NotFound() {
  const { t } = useTranslation()
  return (
    <main className="mx-auto max-w-xl p-6">
      <EmptyState title={t('notFound.title')} body={t('notFound.body')}>
        <Button asChild>
          <Link to="/">{t('notFound.home')}</Link>
        </Button>
      </EmptyState>
    </main>
  )
}
